import styled from '@emotion/styled';
import { InputAdornment, StandardTextFieldProps, TextField } from '@mui/material';

interface Props extends StandardTextFieldProps {
    value: string;
    adornmentPosition: 'start' | 'end';
    show?: boolean;
    children?: React.ReactNode;
}

const StyledTextField = styled(TextField)`
    & .MuiOutlinedInput-root {
        & fieldset {
        }
        &:hover fieldset {
            border: 1px solid ${({ theme }) => theme.colors.secondary.main};
        }
        &.Mui-focused fieldset {
            border: 1px solid ${({ theme }) => theme.colors.secondary.main};
        }
    }
`;

export default function ({ value, children, adornmentPosition, show, ...props }: Props) {
    if (!show) return null;

    return (
        <StyledTextField
            value={value}
            InputProps={{
                endAdornment: <InputAdornment position={adornmentPosition}>{children}</InputAdornment>,
            }}
            {...props}
        />
    );
}
